import React from "react";
import Board from "./Board";

export default function Breakout() {
  return (
    <div>
      <Board />
    </div>
  );
}
